import { POSTAGE_TYPES } from 'assets/js/pages/engage/letters/constants';
import { PageSettingsForm } from 'assets/js/pages/engage/letters/types';
import { EngageLetterGenerateFor, EngageMessage } from 'types/domain';

const transformGeneratePdfLetterForToReadable = (value: EngageLetterGenerateFor) => {
    switch (value) {
        case 'all':
            return 'All contacts';
        case 'individuals':
            return 'Individual contacts only';
        case 'companies':
            return 'Companies only';
        case 'households_only':
            return 'Households only';
    }
};

const transformPageSettingsToRequest = (values: PageSettingsForm) => ({
    page_type: values.letterDimensions,
    page_margin_top: parseFloat(values.letterMarginTop),
    page_margin_bottom: parseFloat(values.letterMarginBottom),
    page_margin_left: parseFloat(values.letterMarginLeft),
    page_margin_right: parseFloat(values.letterMarginRight),
    postage_type: values.postageType?.value ?? 'usps_first_class',
    is_double_sided: values.isDoubleSided,
});

const transformLetterSettingsToForm = (letter?: EngageMessage) => ({
    letterDimensions: letter?.settings.page_type ?? 'letter',
    letterMarginTop: getLetterMargin(letter?.settings.page_margin_top),
    letterMarginBottom: getLetterMargin(letter?.settings.page_margin_bottom),
    letterMarginLeft: getLetterMargin(letter?.settings.page_margin_left),
    letterMarginRight: getLetterMargin(letter?.settings.page_margin_right),
    postageType: POSTAGE_TYPES[letter?.settings.postage_type ?? 'usps_first_class'],
    isDoubleSided: letter?.settings.is_double_sided ?? false,
});

const getLetterMargin = (value?: number | null) => {
    if (typeof value === 'number') {
        return value.toString();
    }

    return '1';
};

export {
    transformGeneratePdfLetterForToReadable,
    transformPageSettingsToRequest,
    transformLetterSettingsToForm,
};
